module.exports = __webpack_public_path__ + "img/undraw_farm_girl_dnpe.0991738e.svg";